export default __webpack_public_path__ + "static/media/arm.3ee07228.png";